let bases = {
  /*生产*/
  api: 'https://support.huodaipin.com/',
  /*灰度*/
  uat: 'http://support.uat.huodaipin.com.cn/',
  /*测试*/
  admin: 'http://support.qa2.huodaipin.com.cn/',
  /*其他同事*/
  jing: 'http://192.168.1.221:8081',
  eli: 'http://192.168.1.160:8080',
  patton: 'http://1.13.171.173:7008/',
  hanson: 'http://192.168.1.131:8080',
  plan: 'http://192.168.1.244:8080/',
  testUat: 'http://support.test.uat.huodaipin.com.cn/',
  dev: 'http://support.dev.huodaipin.com.cn/'
};
let proxyTarget = bases.api;

const ossPath = "https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/web/v1.0.0";

const isProduction = process.env.NODE_ENV === 'production'

let _qrCodeOrigin = {
  // 正式
  main: {
    gzh: ossPath + "/pages/qrCode/main/wx_ems_cnpl.jpg",
    applet: ossPath + "/pages/qrCode/main/wx_applet.jpg",
    wxService: ossPath + "/pages/qrCode/main/wx_service.png",
    serviceUrl: 'https://work.weixin.qq.com/kfid/kfc16fa3e4690016f33'
  },
  // uat
  uat: {
    gzh: ossPath + "/pages/qrCode/uat/wx_ems_cnpl.jpg",
    applet: ossPath + "/pages/qrCode/uat/wx_applet.jpg",
    wxService: ossPath + "/pages/qrCode/uat/wx_service.png",
    serviceUrl: 'https://work.weixin.qq.com/kfid/kfcfb7353f2df77887d'
  },
  // qa1
  qa1: {
    gzh: ossPath + "/pages/qrCode/qa1/wx_ems_cnpl.jpg",
    applet: ossPath + "/pages/qrCode/qa1/wx_applet.jpg",
    wxService: ossPath + "/pages/qrCode/qa1/wx_service.png",
  },
  // qa2
  qa2: {
    gzh: ossPath + "/pages/qrCode/qa1/wx_ems_cnpl.jpg",
    applet: ossPath + "/pages/qrCode/qa1/wx_applet.jpg",
    wxService: ossPath + "/pages/qrCode/qa1/wx_service.png",
    serviceUrl: 'https://work.weixin.qq.com/kfid/kfc938c57163c6f70bf'
  },
}

let qrCodeImages = _qrCodeOrigin.main;
if (isProduction) {
  if (typeof location !== "undefined" && location.hostname) {
    let isQa1 = ["qa1.huodaipin.com.cn"].includes(location.hostname);
    let isQa2 = ["qa2.huodaipin.com.cn"].includes(location.hostname);
    let isUat = ["uat.huodaipin.com.cn"].includes(location.hostname);
    console.log("isUat = ", isUat, "isQa1 = ", isQa1);
    if (isQa1) qrCodeImages = _qrCodeOrigin.qa1;
    if (isQa2) qrCodeImages = _qrCodeOrigin.qa2;
    else if (isUat) qrCodeImages = _qrCodeOrigin.uat;
  }
} else {
  qrCodeImages = _qrCodeOrigin.qa2;
}
module.exports = { proxyTarget, qrCodeImages, ossPath, isProduction };



//////////////////
// WEBPACK FOOTER
// ./devParams.js
// module id = Fone
// module chunks = 28